import * as React from 'react';
// mui
import {
  Box,
  IconButton,
  ListItemButton,
  ListItemIcon,
  useTheme,
  useMediaQuery,
  Divider,
} from '@mui/material';
// icons
import EventIcon from '@mui/icons-material/Event';
// redux
import { useSelector } from 'react-redux';
import { selectEventById } from '../../../store/selectors/eventSelectors';
// types
import Event from '../../../interfaces/Event.interface';
// components
import EventItemContent from './EventItemContent';
import EventDialog from './EventDialog';
import EventItemActions from './EventItemActions';

interface EventItemProps {
  padding: number;
  parentTaskId: number | null;
  eventId: number;
  showProject?: boolean;
}

export default function EventItem(props: EventItemProps) {
  // hooks
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // props
  const eventId: number = props.eventId;
  const inheritedPadding: number = isMobile ? props.padding / 2 : props.padding;
  const parentTaskId: number | null = props.parentTaskId;
  const showProject = props.showProject || false;

  // redux
  const localEvent: Event = useSelector(selectEventById(eventId)) as Event;

  // local state
  const [ editEventDialogStatus, setEditEventDialogStatus ] = React.useState(false);
  const [ itemIsHovered, setItemIsHovered ] = React.useState<boolean>(false);

  const openEditDialog = () => setEditEventDialogStatus(true);
  const closeEditDialog = () => setEditEventDialogStatus(false);

  const handleEditDialogSave = () => {
    setEditEventDialogStatus(false);
  }

  return (
    <Box>
      <ListItemButton
        sx={{ pl: inheritedPadding+1, pr: isMobile ? 1 : '' }}
        onClick={openEditDialog}
        onMouseEnter={() => setItemIsHovered(true)}
        onMouseLeave={() => setItemIsHovered(false)}
      >
        {/* dropdown button with dynamic icon */}
        <ListItemIcon
          sx={{ minWidth: isMobile ? 36 : 46, color: 'lightgrey' }}
        >
          <IconButton
            sx={{ p: isMobile ? 1 : '' }}
            disabled={localEvent.completed} // this is just to change the color
            disableRipple // this stops it from functioning like a button
          >
            <EventIcon />
          </IconButton>
        </ListItemIcon>

        {/* task information */}
        <EventItemContent
          eventId={localEvent.id}
          showProject={showProject}
        />

        {/* task actions */}
        <EventItemActions
          eventId={localEvent.id}
          parentTaskId={parentTaskId}
          isHovered={itemIsHovered}
        />
      </ListItemButton>
      <Divider sx={{ ml: (isMobile ? inheritedPadding+1 : inheritedPadding), mr: isMobile ? '8px' : 'auto' }} />

      {/* dialog for editing */}
      { editEventDialogStatus &&
        <EventDialog
          parentTaskId={parentTaskId}
          onSave={handleEditDialogSave}
          onCancel={closeEditDialog}
          eventId={localEvent.id}
          addMode={false}
        />
      }
    </Box>
  );
}
